import fontFamily from '../../util/fontFamily';

const monospace = {
  // fontFamily: fontFamily('Calibri', 'Arial', 'Consolas', 'Courier New', 'monospace')
  fontFamily: fontFamily('Consolas', 'Courier New', 'monospace')
};

export {
  monospace
}



// WEBPACK FOOTER //
// ./src/ui/styles/fonts.js